import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { HiAdjustmentsHorizontal } from "react-icons/hi2";
import { useSelector } from "react-redux";

function Sidebar({ image, routes, sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { isPolicyAccepted, isJoiningFormCompleted, isExistingEmp } =
    useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) ||
    {};
  const [openSubmenu, setOpenSubmenu] = useState("Dashboard");
  const [activeMenu, setActiveMenu] = useState("");
  // Set active menu based on current URL
  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  const toggleSubmenu = (menuItem) => {
    // Check if it has visible children
    const hasVisibleChildren = menuItem.children?.some(
      (child) => child.inSidebar,
    );

    if (hasVisibleChildren) {
      setOpenSubmenu(openSubmenu === menuItem.name ? "" : menuItem.name);
    } else if (menuItem.path) {
      navigate(menuItem.path);
      setSidebarOpen(false);
    }
  };

  return (
    <div className={`sidebar ${sidebarOpen ? "open" : ""}`} data-image={image}>
      <div className="sidebar-background" />
      <div className="sidebar-wrapper">
        <Nav>
          {routes.map((prop) => {
            // only render if inSidebar is true
            if (!prop.inSidebar) return null;
            const isActive = activeMenu === prop.path;
            const currentRole = localStorage.getItem("role");
            const isSuperAdmin = currentRole === "SUPER_ADMIN";
            const isDisabled =
              (!isJoiningFormCompleted || !isPolicyAccepted || isExistingEmp) &&
              !isSuperAdmin;

            // Count visible children once to use in multiple places
            const visibleChildren =
              prop.children?.filter((child) => child.inSidebar) || [];

            return (
              <React.Fragment key={prop.name}>
                <li className={`nav-item ${isActive ? "active" : ""}`}>
                  <button
                    className="nav-link btn-interactive"
                    disabled={isDisabled}
                    style={{
                      cursor: !isDisabled ? "pointer" : "not-allowed",
                      opacity: !isDisabled ? 1 : 0.5,
                    }}
                    onClick={() => toggleSubmenu(prop)}
                  >
                    {prop.icon === "custom-circle" ? (
                      <i className="custom-circle">
                        <span className="dots">...</span>
                      </i>
                    ) : (
                      <img
                        src={prop.icon}
                        alt={prop.name}
                        style={{
                          width: "22px",
                          height: "22px",
                          margin: "0px 10px 0px 5px",
                        }}
                      />
                    )}

                    <p className={isActive ? "active" : ""}>{prop.name}</p>
                    {/* Show dropdown icon if menu has children */}
                    {visibleChildren.length > 0 && (
                      <img
                        src={require("assets/img/dropdown_icon.png")}
                        alt="arrow"
                        style={{
                          width: "10px",
                          height: "10px",
                          marginLeft: "10px",
                          transform:
                            openSubmenu === prop.name
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "0.3s",
                        }}
                      />
                    )}
                  </button>
                </li>

                {/* Simplified Sub-menu Logic */}
                {visibleChildren.length > 0 && openSubmenu === prop.name && (
                  <ul className="subdropdown">
                    {visibleChildren.map((child) => (
                      <li className="nav-item" key={child.path}>
                        <NavLink
                          to={child.path}
                          className="nav-link"
                          onClick={() => setSidebarOpen(false)}
                        >
                          <HiAdjustmentsHorizontal />
                          <p
                            className={
                              location.pathname === child.path ? "active" : ""
                            }
                          >
                            {child.name}
                          </p>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            );
          })}
        </Nav>
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  image: PropTypes.string,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string,
      inSidebar: PropTypes.bool,
      children: PropTypes.array,
    }),
  ).isRequired,
};

export default Sidebar;
